
const OnlineStorePublishable = {
  "name": "OnlineStorePublishable",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "onlineStoreUrl": "URL"
  },
  "possibleTypes": ["Article", "Blog", "Collection", "Page", "Product"]
};
export default OnlineStorePublishable;